import React from 'react';
import PropTypes from 'prop-types';

export class BadgeLabel extends React.Component {

    render() {
        const {
            label,
            style,
        } = this.props;

        const colors = {
            backgroundColor: '#777777',
            color: '#FFFFFF',
            ...style,
        };

        return (
            <span
                className="label"
                style={colors}
                children={label}
            />
        );
    }

}

BadgeLabel.propTypes = {
    label: PropTypes.string.isRequired,
    style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/BadgeLabel.js